export * from './device-with-battery.class';

export * from './device-with-battery-info.component';